import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "dropzone"]

  connect() {
    this.setupDragAndDrop()
  }

  setupDragAndDrop() {
    const dropzone = this.dropzoneTarget
    ;["dragenter", "dragover"].forEach(event => {
      dropzone.addEventListener(event, (e) => {
        e.preventDefault()
        dropzone.classList.add("border-emerald-500", "bg-emerald-50")
      })
    })
    ;["dragleave", "drop"].forEach(event => {
      dropzone.addEventListener(event, (e) => {
        e.preventDefault()
        dropzone.classList.remove("border-emerald-500", "bg-emerald-50")
      })
    })
    dropzone.addEventListener("drop", (e) => {
      this.inputTarget.files = e.dataTransfer.files
      this.showPreviews()
    })
  }

  selectFiles() {
    this.inputTarget.click()
  }

  showPreviews() {
    this.previewTarget.innerHTML = ""
    Array.from(this.inputTarget.files).forEach(file => {
      const reader = new FileReader()
      reader.onload = (e) => {
        const img = document.createElement("img")
        img.src = e.target.result
        img.className = "w-24 h-24 object-cover rounded-lg"
        this.previewTarget.appendChild(img)
      }
      reader.readAsDataURL(file)
    })
  }
}
